import React, {Component} from 'react';
import {Trans, translate} from 'react-i18next';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import ReactPasswordStrength from 'react-password-strength';


class FormRegisterView extends Component {

  render() {
    const {
      email,
      first_name,
      last_name,
      phone,
      isAgree,
      subscription
    } = this.props.state;
    const {handleChange, errors, t, passwordCallback, language} = this.props;
    return (
      <div className="form form--register">
        <div className="form__row form__row--columns">
          <div
            className={
              classNames({
                "form__column" : true,
                "form__column--invalid": errors && errors.first_name
              })
            }
          >
            <input
              name='first_name'
              type="text"
              placeholder={t('first_name')}
              className={
                classNames({
                  'input input--block': true,
                  'input--invalid': errors && errors.first_name,
                })
              }
              value={first_name}
              onChange={handleChange}
              autoComplete='off'
            />
            {errors && errors.first_name &&
              <p>{t('error_empty_filed')}</p>
            }
          </div>

          <div
            className={
              classNames({
                "form__column" : true,
                "form__column--invalid": errors && errors.last_name
                })
              }
          >
            <input
              name='last_name'
              type="text"
              placeholder={t('last_name')}
              className={
                classNames({
                  'input input--block': true,
                  'input--invalid': errors && errors.last_name,
                })
              }
              value={last_name}
              onChange={handleChange}
              autoComplete='off'
            />

            {errors && errors.last_name &&
              <p>{t('error_empty_filed')}</p>
            }
          </div>

        </div>
        <div className="form__row">
          <input
            name='phone'
            type="tel"
            placeholder={t('phone_number')}
            className={
              classNames({
                'input input--block': true,
                'input--invalid': errors && errors.phone,
              })
            }
            value={phone}
            onChange={handleChange}
            autoComplete='off'
          />
        </div>
        {errors && errors.phone && phone &&
        <div className="form__row form__row--invalid">
          <p>{t('error_phone')}</p>
        </div>
        }
        {errors && errors.phone && !phone &&
        <div className="form__row form__row--invalid">
          <p>{t('error_empty_filed')}</p>
        </div>
        }
        <div className="form__row">
          <input
            name='email'
            autoComplete='off'
            type="text"
            placeholder={t('email')}
            className={
              classNames({
                'input input--block': true,
                'input--invalid': errors && errors.email,
              })
            }
            value={email}
            onChange={handleChange}
          />
        </div>
        {errors && errors.email && !email &&
        <div className="form__row form__row--invalid">
          <p>{t('error_empty_filed')}</p>
        </div>
        }
        {errors && errors.email && email &&
        <div className="form__row form__row--invalid">
          <p>{t('email_wrong')}</p>
        </div>
        }
        {errors && errors.email_unique &&
        <div className="form__row form__row--invalid">
          <p>{t('error_unique_email')}</p>
        </div>
        }
        <div className="form__row">
          <ReactPasswordStrength
            className='input input--block'
            minLength={6}
            minScore={2}
            scoreWords={[]}
            tooShortWord={''}
            changeCallback={passwordCallback}
            inputProps={{ name: "password", autoComplete: "off", placeholder: t('new_password'),
              className: classNames({'input--invalid': errors && errors.password,})
            }}
          />
        </div>
        {errors && errors.password &&
        <div className="form__row form__row--invalid">
          <p>{t('error_password')}</p>
        </div>
        }
        <div className="form__row">
          <label className="checkbox">
            <input
              name="subscription"
              type="checkbox"
              className="checkbox__input"
              checked={subscription}
              onChange={handleChange}
            />
            <span className="checkbox__text">
            </span>
          </label>
          <span className="checkbox-label">
            {t('confirm_subscription')}
          </span>
        </div>
        <div className="form__row">
          <label className="checkbox">
            <input
              name="isAgree"
              type="checkbox"
              className="checkbox__input"
              checked={isAgree}
              onChange={handleChange}
            />
            <span className="checkbox__text">
            </span>
          </label>
          <span className="checkbox-label">
            <Trans i18nKey="confirm_terms">
              I agree to the
              <Link to={`/${language}/terms`} target="_blank">Terms Of Use</Link>
               and understand that my information will be used as described on this page and the Pizza Hut
              <Link to={`/${language}/policy`} target="_blank">Privacy Policy</Link>
            </Trans>
          </span>
        </div>
      </div>
    );
  }
}

export default translate('translations')(FormRegisterView);



// WEBPACK FOOTER //
// ./src/components/Customer/Auth/FormRegisterView.js